<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-overlay :show="isLoading" class="m-3 mt-n10" no-center>
      <template v-slot:overlay>
        <div class="d-flex mt-5">
          <div class="m-auto">
            <b-icon icon="stopwatch" font-scale="3" animation="cylon"/>
            <p>Carregando...</p>
          </div>
        </div>
      </template>
      <b-card class="m-3 mt-n10">
        <b-form @submit="onSubmit">
          <b-form-group label-cols-lg="2" :label="$t('integration.form.fieldsets.informacoes')" label-size="lg"
                        label-class="font-weight-bold pt-0" class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.nome.description')"
                :label="$t('integration.form.fields.nome.label')"
                label-for="input-name"
            >
              <b-form-input id="input-name" v-model="integration.name"/>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.mnemonico.description')"
                :label="$t('integration.form.fields.mnemonico.label')"
                label-for="input-mnemonico"
            >
              <b-form-input id="input-mnemonico" v-model="integration.mnemonic"/>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.tipo_integracao.description')"
                :label="$t('integration.form.fields.tipo_integracao.label')"
                label-for="input-integration_type"
            >
              <v-select
                  id="input-integration_type"
                  class="w-100"
                  :value="integration.integration_type"
                  @input="i => setIntegration('integration_type', i)"
                  :options="types"
              />
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.fabricante.description')"
                :label="$t('integration.form.fields.fabricante.label')"
                label-for="input-manufacturer"
            >
              <b-overlay :show="manufacturersLoading">
                <v-select
                    id="input-manufacturer"
                    class="w-100"
                    :value="integration.vns_manufacturer_id"
                    @input="m => setIntegration('vns_manufacturer_id', m)"
                    :options="manufacturers"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
          </b-form-group>

          <b-form-group label-cols-lg="2" :label="$t('integration.form.fieldsets.comunicacao')" label-size="lg"
                        label-class="font-weight-bold pt-0" class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.protocolo.description')"
                :label="$t('integration.form.fields.protocolo.label')"
                label-for="input-protocol"
            >
              <b-overlay :show="protocolsLoading">
                <v-select
                    id="input-protocol"
                    class="w-100"
                    :value="integration.vns_protocol_id"
                    @input="p => setIntegration('vns_protocol_id', p)"
                    :options="protocols"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.formato_arquivo.description')"
                :label="$t('integration.form.fields.formato_arquivo.label')"
                label-for="input-fileformat"
            >
              <b-overlay :show="fileformatsLoading">
                <v-select
                    id="input-fileformat"
                    class="w-100"
                    :value="integration.vns_file_format_id"
                    @input="m => setIntegration('vns_file_format_id', m)"
                    :options="fileformats"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.pubsub_topic_result_out.description')"
                :label="$t('integration.form.fields.pubsub_topic_result_out.label')"
                label-for="input-pubsub_topic_result_out"
            >
              <b-form-input id="input-pubsub_topic_result_out" v-model="integration.pubsub_topic_result_out"/>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.pubsub_topic_order_out.description')"
                :label="$t('integration.form.fields.pubsub_topic_order_out.label')"
                label-for="input-pubsub_topic_order_out"
            >
              <b-form-input id="input-pubsub_topic_order_out" v-model="integration.pubsub_topic_order_out"/>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.pubsub_topic_label_out.description')"
                :label="$t('integration.form.fields.pubsub_topic_label_out.label')"
                label-for="input-pubsub_topic_label_out"
            >
              <b-form-input id="input-pubsub_topic_label_out" v-model="integration.pubsub_topic_label_out"/>
            </b-form-group>
          </b-form-group>

          <b-form-group label-cols-lg="2" :label="$t('integration.form.fieldsets.hosts')" label-size="lg"
                        label-class="font-weight-bold pt-0" class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.host_homologacao.description')"
                :label="$t('integration.form.fields.host_homologacao.label')"
                label-for="input-host_development"
            >
              <b-form-input id="input-host_development" v-model="integration.host_development"/>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.host_producao.description')"
                :label="$t('integration.form.fields.host_producao.label')"
                label-for="input-host_production"
            >
              <b-form-input id="input-host_production" v-model="integration.host_production"/>
            </b-form-group>
          </b-form-group>

          <b-form-group label-cols-lg="2" :label="$t('integration.form.fieldsets.camada')" label-size="lg"
                        label-class="font-weight-bold pt-0" class="mb-0">
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.empresa.description')"
                :label="$t('integration.form.fields.empresa.label')"
                label-for="input-companies"
            >
              <b-overlay :show="companiesLoading">
                <v-select
                  id="input-companies"
                  class="w-100"
                  :value="integration.empresa_id"
                  @input="c => setVns('empresa_id', c)"
                  :options="companies"
                  :reduce="option => option.id"
                  label="name"
              />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('integration.form.fields.equipamento.description')"
                :label="$t('integration.form.fields.equipamento.label')"
                label-for="input-equipment"
            >
              <v-select
                  id="input-equipment"
                  class="w-100"
                  :value="integration.equipment"
                  :options="equipments"
                  @input="(v) => {setIntegration('equipment', v)}"
              />
            </b-form-group>
          </b-form-group>
        
          <b-form-group
              :label="$t('integration.form.fields.bloquear_dexpara.label')"
              label-for="input-block_when_error"
              :description="$t('integration.form.fields.bloquear_dexpara.description')"
          >
            <b-form-checkbox id="input-block_when_error" v-model="integration.block_when_error" size="lg" switch/>
          </b-form-group>

          <b-form-group
              :label="$t('integration.form.fields.sport.label')"
              label-for="input-sport"
              :description="$t('integration.form.fields.sport.description')"
          >
            <b-form-checkbox id="input-sport" v-model="integration.sport" size="lg" switch/>
          </b-form-group>

          <b-form-group
              :label="$t('integration.form.fields.bypass_material_complement.label')"
              label-for="input-bypass_material_complement"
              :description="$t('integration.form.fields.bypass_material_complement.description')"
          >
            <b-form-checkbox id="input-bypass_material_complement" v-model="integration.bypass_material_complement" size="lg" switch/>
          </b-form-group>

          <b-form-group
              :label="$t('integration.form.fields.status.label')"
              label-for="input-status"
              :description="$t('integration.form.fields.status.description')"
          >
            <b-form-checkbox id="input-status" v-model="integration.status" size="lg" switch/>
          </b-form-group>
          <b-button type="submit" variant="success">
            <i class="fas fa-save"/> {{ $t('integration.form.fields.botao_salvar') }}
          </b-button>
        </b-form>
      </b-card>
    </b-overlay>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient"
import Loading from "@/components/Loading";
import IntegrationRepository from '@/repositories/vns/IntegrationRepository'
import vSelect from 'vue-select'
import {mapActions, mapGetters} from "vuex"

export default {
  name: "Form",
  components: {
    Loading,
    LayoutGradient,
    vSelect
  },
  computed: {
    ...mapGetters({
      integration: 'integration/current',
      store_isLoading: 'integration/isLoading',
      types: 'integration/types',
      fileformats: 'fileformat/all',
      fileformatsLoading: 'fileformat/isLoading',
      manufacturers: 'manufacturer/all',
      manufacturersLoading: 'manufacturer/isLoading',
      protocols: 'protocol/all',
      protocolsLoading: 'protocol/isLoading',
      equipments: 'integration/equipments',
      companies: 'corecompanies/all',
      companiesLoading: 'corecompanies/isLoading',
    }),
    pageTitle() {
      if (this.integration_id) return this.$t('integration.form.titulo_pagina.editar')
      return this.$t('integration.form.titulo_pagina.criar')
    },
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      integration_id: null
    }
  },
  methods: {
    ...mapActions([
      'integration/listTypes',
      'manufacturer/search',
      'protocol/search',
      'fileformat/search',
      'corecompanies/listAll',
      'integration/listEquipments',
      'integration/listOne'
    ]),
    setIntegration(key, value) {
      this.$store.commit('integration/setCurrent', {...this.integration, [key]: value})
    },
    async autocomplete(string) {
      if (string.length >= 3) {
        await this['corecompanies/listAll']({mapping: true, nome: string})
      }
    },
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    isPossibleSpecimensLinkedError(error) {
      const data = error.response && error.response.data ? error.response.data : {}
      return data.message === 'VWS-EG-3011' || data.data === 'VWS-EG-3011'
    },
    create() {
      IntegrationRepository.post(this.integration).then(() => {
        this.$snotify.success(this.$t('integration.form.create.success'))
        this.$router.push({name: 'vns.integration'})
      }).catch(error => {
        if (this.isPossibleSpecimensLinkedError(error)) {
          this.$snotify.error(this.$t('integration.form.errors.possible_specimens_linked'))
          return
        }
        this.$snotify.error(this.$t('integration.form.create.error'))
        if (error.response.status === 422) {
          IntegrationRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      IntegrationRepository.put(this.integration_id, this.integration).then(() => {
        this.$snotify.success(this.$t('integration.form.update.success'))
        this.$router.push({name: 'vns.integration'})
      }).catch(error => {
        if (this.isPossibleSpecimensLinkedError(error)) {
          this.$snotify.error(this.$t('integration.form.errors.possible_specimens_linked'))
          return
        }
        this.$snotify.error(this.$t('integration.form.update.error'))
        if (error.response.status === 422) {
          IntegrationRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('integration/setCurrent', {})
    this['integration/listTypes']()
    this['manufacturer/search']()
    this['protocol/search']()
    this['fileformat/search']()
    this['corecompanies/listAll']({mapping: true})
    this['integration/listEquipments']()
    if (this.$route.params.id) {
      this.integration_id = this.$route.params.id
      await this['integration/listOne'](this.$route.params.id)
      if (this.integration.empresa) await this['corecompanies/listAll']({
        mapping: true,
        id: this.integration.empresa
      })
      if (this.integration.manufacturer && this.integration.manufacturer.id) {
        this.setIntegration('vns_manufacturer_id', this.integration.manufacturer.id)
      }
      if (this.integration.protocol && this.integration.protocol.id) {
        this.setIntegration('vns_protocol_id', this.integration.protocol.id)
      }
      if (this.integration.file_format && this.integration.file_format.id) {
        this.setIntegration('vns_file_format_id', this.integration.file_format.id)
      }
      if (this.integration.empresa && this.integration.empresa.id) {
        this.setIntegration('empresa_id', this.integration.empresa.id)
      }
      if (this.integration.equipamento && this.integration.equipamento.id) {
        this.setIntegration('equipamento_id', this.integration.equipamento.id)
      }
    }
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
